import React from 'react';
import { Route, Routes, } from 'react-router-dom';
import './App.css';
import Login from './components/Login/Login';
import Electricidad from './components/Electricidad/Electricidad';
import Ahorro from './components/Ahorro/Ahorro';
import Renovable from './components/Renovable/Renovable';
import Aire from './components/Aire/Aire';
import Equipos from './components/Equipos/Equipos';
import Arqui from './components/Arqui/Arqui';
import Contacto from './components/Contacto/Contacto';
function App() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/Electricidad" element={<Electricidad />} />
      <Route path="/Ahorro" element={<Ahorro />} />
      <Route path="/Renovable" element={<Renovable />} />
      <Route path="/Aire" element={<Aire />} />
      <Route path="/Equipos" element={<Equipos />} />
      <Route path="/Arquitectura" element={<Arqui />} />
      <Route path="/Contacto" element={<Contacto />} />
    </Routes>
  );
}

export default App;
